import { ColumnDef } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

import TableHeader from '../common/TableHeader';
import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import Table from '@/components/table/common/Table';
import { orderFilterList } from '@/components/utils/constants';
import { useUser } from '@/hooks/useUser';
import { ICollection } from '@/interfaces/api/collection/ICollection';
import { ICollectionOrder } from '@/interfaces/api/orders/ICollectionOrder';
import { IOrder } from '@/interfaces/api/orders/IOrder';
import { IOrderWithAction } from '@/interfaces/api/orders/IOrderWithAction';
import { UserRole } from '@/interfaces/api/user/UserRole.enum';

const OrderTable = ({
	collection,
	paginationOption,
	columns,
	refetch,
	query,
	setQuery,
	setFilterSelected,
}: {
	collection: ICollectionOrder;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IOrderWithAction, any>[];
	refetch: () => void;
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;

	setFilterSelected: (filterValue: string) => void;
}) => {
	const { user } = useUser();
	const userIsConsumer = user?.roles.includes(UserRole.Consumer);
	const handleCollectionWithAction = (
		collection: ICollectionOrder,
	): ICollection<IOrderWithAction> => ({
		...collection,
		data: collection.data.map((item: IOrder) => ({
			...item,
			action: '',
		})),
	});

	const navigate = useNavigate();
	const handleSelectRow = (selectedOrder: IOrder) => {
		navigate(
			`/${userIsConsumer ? 'customer' : 'user/dashboard'}/orders/${
				selectedOrder.id
			}`,
		);
	};

	return (
		<>
			<TableHeader
				title="Order List"
				counts={[
					{
						label: 'Total Orders',
						value: collection.itemCount,
						dataTest: 'total-orders-count',
					},
				]}
				searchConfigs={[
					{
						query: query,
						setQuery: setQuery,
						placeholder: 'Search by order ID',
						refetch: refetch,
					},
				]}
				filterConfig={{
					setFilterSelected: setFilterSelected,
					filterList: orderFilterList,
				}}
			/>
			<div className="mx-2 pb-[2rem] bg-grey-0 border-l border-r border-b border-gray-300 rounded-xl">
				{collection?.data?.length === 0 ? (
					<div className="flex flex-col items-center justify-center py-10 px-4">
						<h3 className="text-grey-90 font-semibold text-lg mb-1">
							No orders found
						</h3>
						<p className="text-grey-50 text-center">
							Try adjusting your search or filter to find what you're looking
							for.
						</p>
					</div>
				) : (
					<Table<IOrderWithAction>
						collection={handleCollectionWithAction(collection)}
						columns={columns}
						paginationSection={paginationOption}
						tableStyles={{
							tableBox: 'w-full overflow-y-auto h-fit',
							table: 'w-full',
						}}
						handleSelectRow={handleSelectRow}
					/>
				)}
			</div>
		</>
	);
};

export default OrderTable;
